import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import CharacterOption from "../../../../model/CharacterOption";
import ImageLink from "../../../../components/image-link/ImageLink";
import ContentBox from "../../../../components/content-box/ContentBox";
import PageActions from "../../../base/PageActions";
import _http_service from "../../../../services/HttpService";
import _image_service from "../../../../services/ImageService";
import _naming_service from "../../../../services/NamingService";
import '../../../styles/Common.scss';
import './CharactersPage.scss';

interface CharactersPageProps {
}

const CharactersPage = (props: CharactersPageProps) => {

    const page: PageActions = new PageActions({
        title: `Characters - Chase the Fox`,
        description: `Meet Chase and his colorful cast of cartoony characters!`,
        keywords: ["furry oc", "character", "casarok", "anthropomorphic", "toon"],
        imgSrc: `chase/assets/chase_full.png`,
        url: `characters`
    });

    const [hasFetchedList, setFetchedList] = useState<boolean>(false);

    const navigateTo = useNavigate();

    const list = useRef<CharacterOption[]>();

    useEffect(() => {
        _http_service.getCharacterOptions()
            .then(response => {
                if (!response || response.length === 0) {
                    list.current = [];
                } else {
                    list.current = response;
                }
            })
            .catch(() => navigateTo("/error", {replace: false}))
            .finally(() => setFetchedList(true));
    }, []);

    return page.generateMetaContent(
        <>
            <ContentBox header="Chase's world has a colorful cast of cartoony characters! Click on one to learn more about them.">
                <h3 className="headline">Protagonists</h3>
                <div className="character-lineup">
                    {hasFetchedList && list.current?.filter(option => option.category === 'PRESENT' && option.alignment === 'PROTAGONIST')
                        .map(option =>
                            <ImageLink
                                key={`character-present-${option.shortName}`}
                                imgSrc={_image_service.getCdnImageSrc(`chase/characters/${option.shortName}/1.png`)}
                                linkUrl={option.shortName}
                                linkName={`${_naming_service.capitalizeName(option.shortName)}`}/>
                    )}
                </div>
                <h3 className="headline">Antagonists</h3>
                <div className="character-lineup">
                    {hasFetchedList && list.current?.filter(option => option.category === 'PRESENT' && option.alignment === 'ANTAGONIST')
                        .map(option =>
                            <ImageLink
                                key={`character-present-${option.shortName}`}
                                imgSrc={_image_service.getCdnImageSrc(`chase/characters/${option.shortName}/1.png`)}
                                linkUrl={option.shortName}
                                linkName={`${_naming_service.capitalizeName(option.shortName)}`}/>
                    )}
                </div>
                <h3 className="headline">Neutral/Not Yet Introduced</h3>
                <div className="character-lineup">
                    {hasFetchedList && list.current?.filter(option => option.category === 'PRESENT' && !option.alignment)
                        .map(option =>
                            <ImageLink
                                key={`character-present-${option.shortName}`}
                                imgSrc={_image_service.getCdnImageSrc(`chase/characters/${option.shortName}/1.png`)}
                                linkUrl={option.shortName}
                                linkName={`${_naming_service.capitalizeName(option.shortName)}`}/>
                    )}
                </div>
                <h3 className="headline">Characters From the Past of Casarok</h3>
                <div className="character-lineup">
                    {hasFetchedList && list.current?.filter(option => option.category === 'PAST')
                        .map(option =>
                            <ImageLink
                                key={`character-past-${option.shortName}`}
                                imgSrc={_image_service.getCdnImageSrc(`chase/characters/${option.shortName}/1.png`)}
                                linkUrl={option.shortName}
                                linkName={`${_naming_service.capitalizeName(option.shortName)}`}/>
                    )}
                </div>
            </ContentBox>
        </>
    );
}

export default CharactersPage;